import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { PhotoFrame } from '../ui/PhotoFrame';
import { ScriptEyebrow } from '../ui/ScriptEyebrow';
import { Reveal, stagger } from '../motion/Reveal';
import { FloatingPhoto } from '../motion/FloatingPhoto';
import { DoodleSquiggle } from '../brand/Doodles';
import { mosaicPhotos } from '../../data/photos';
import { externalLinks } from '../../data/site';

// Balanced 4-up mosaic: wide photos span two columns at a 2:1 ratio so they sit
// flush with the square photos beside them at every breakpoint.
const mosaic = mosaicPhotos;

// Varied, non-synchronised drift settings so the grid never pulses as one block.
const drift = [{
  range: 5,
  duration: 7,
  delay: 0
}, {
  range: 4,
  duration: 8.5,
  delay: 0.6
}, {
  range: 6,
  duration: 6.5,
  delay: 1.2
}, {
  range: 4,
  duration: 9,
  delay: 0.3
}, {
  range: 5,
  duration: 7.5,
  delay: 0.9
}, {
  range: 3,
  duration: 8,
  delay: 1.5
}];
export function PhotoMosaic() {
  return <Section className="bcm-paper overflow-hidden py-16 sm:py-20" labelledBy="gallery-heading" data-id="element-208" data-mp="3id0np6xjx0rr">
      <Container data-id="element-209" data-mp="3na8ygmgde2iz">
        <Reveal data-id="element-210" data-mp="3nashk6hrawyl">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-211" data-mp="3ndeny2swv6f8">
            <div className="max-w-xl" data-id="element-212" data-mp="39ici1fo2dh2f">
              <ScriptEyebrow accent="var(--bcm-pink)" data-id="element-213" data-mp="3dkz40zy207rp">Life at BCM</ScriptEyebrow>
              <h2 id="gallery-heading" className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-[2.75rem]" data-id="element-214" data-mp="2zm93tbfxtrz4">
                Real moments from this year
              </h2>
              <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-215" data-mp="2qne0q886wy01">
                Worship nights, campus outreach, recreation, community groups, and the moments in
                between.
              </p>
            </div>
            <DoodleSquiggle className="hidden h-8 w-32 shrink-0 sm:block" color="var(--bcm-dark-blue)" data-id="element-216" data-mp="sw1kdwn1chor" />
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-217" data-mp="1wtdd87qd0eps">
          {mosaic.map((photo, index) => {
          const isWide = index === 0 || index === 3;
          const motionProps = drift[index % drift.length];
          return <Reveal key={photo.id} delay={stagger(index)} className={isWide ? 'col-span-2' : ''} data-id="element-218" data-mp="1nu9vp86uc7de" data-mpi={index}>
                <FloatingPhoto {...motionProps} data-id="element-219" data-mp="2gguo8bz1ypij">
                  <PhotoFrame photo={photo} ratio={isWide ? 'aspect-[2/1]' : 'aspect-square'} className="transition-transform duration-300 hover:scale-[1.02]" data-id="element-220" data-mp="2gjh3yyw3kbbu" />
                </FloatingPhoto>
              </Reveal>;
        })}
        </div>

        <Reveal delay={0.1} data-id="element-221" data-mp="2zgiaio5aujhw">
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-222" data-mp="2zf76qobutbqs">
            <ButtonLink to="/photos" data-id="element-223" data-mp="36rmwbzujvg3t">View BCM Photos</ButtonLink>
            <ButtonExternal href={externalLinks.photoAlbum} variant="secondary" data-id="element-224" data-mp="36t7qhocycx15">
              Open Full Photo Album
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}